module.exports = __webpack_public_path__ + "static/media/fal_fal_blo_cor.0c81661f.png";